import styled from 'styled-components';
import { palette } from 'styled-theme';
import { WithDirection, device } from '@jjj/components';
import { transition, borderRadius, boxShadow } from '../../settings/style-util';

const TopbarDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${palette('grayscale', 4)};
  margin: -12px -16px;
  width: 100%;
  min-width: 160px;
  flex-shrink: 0;
  ${borderRadius('5px')};
  ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
  ${transition()};
  border-radius: 3px;
  box-shadow: 0 4px 16px 0 rgba(78, 93, 109, 0.24);

  .notification-icon-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
  }

  @media ${device.tablet} {
    width: 360px;
  }

  .isoDropdownHeader {
    border-bottom: 1px solid #f1f1f1;
    margin-bottom: 0px;
    padding: 16px 21px 7px 21px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 344px;
    background: ${palette('grayscale', 5)};
    width: 100%;

    h3 {
      color: ${palette('grayscale', 0)};
      text-align: left;
      text-transform: capitalize;
      margin: 0;
      font-size: 14px;
      font-weight: 900;
      letter-spacing: 0.35px;
    }
  }

  .isoDropdownBody {
    width: 100%;
    height: 280px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background-color: ${palette('grayscale', 5)};

    a {
      text-decoration: none;
      display: flex;
      align-items: center;
      line-height: 1.4;

      * {
        line-height: 1.4;
      }

      &:hover {
        background-color: ${palette('grayscale', 3)};
      }

      &.unread {
        width: 100%;
        display: flex;
        background-color: ${palette('grayscale', 4)};
      }
    }

    .isoDropdownListItem {
      padding: ${props => (props['data-rtl'] === 'rtl' ? '12px 24px 12px 5px' : '12px 5px 12px 24px')};
      width: 100%;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      text-decoration: none;
      text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      border-bottom: 1px solid ${palette('border', 0)};
      ${transition()};

      .isoListHead {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 5px;
      }

      h5 {
        color: ${palette('grayscale', 0)};
        margin-top: 0;
        font-size: 12px;
        font-weight: 900;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.08;
        letter-spacing: normal;
        margin-bottom: 5px;
        line-height: 1.2;
      }

      p,
      div.isoListItem {
        color: ${palette('grayscale', 1)};
        overflow: hidden;
        font-size: 11px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: normal;
      }

      .isoDate {
        font-size: 11px;
        color: ${palette('grayscale', 1)};
        flex-shrink: 0;
      }
    }

    .circle {
      display: inline;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      border: 2px solid grey;
      margin-left: ${props => (props['data-rtl'] === 'rtl' ? '10px' : 'auto')};
      margin-right: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '10px')};

      &.unread {
        border: 2px solid ${palette('primary', 0)};
        background-color: ${palette('primary', 0)};
      }

      &-button {
        border: 0;
        cursor: pointer;
        width: 100%;
        display: flex;
        background: transparent;

        &:focus {
          outline: 0;
        }
      }
    }
  }

  .isoViewAllBtn {
    font-size: 13px;
    font-weight: 500;
    color: ${palette('secondary', 0)};
    padding: 16px 15px 14px 15px;
    display: flex;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${palette('grayscale', 5)};
    border-top: 2px solid ${palette('grayscale', 4)};
    ${transition()};

    span {
      font-size: 13px;
      font-weight: 900;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.08;
      letter-spacing: normal;
      color: ${palette('secondary', 0)};
    }

    &:hover {
      color: ${palette('primary', 0)};
    }
  }

  .isoDropdownFooterLinks {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px 20px;

    a {
      font-size: 13px;
      font-weight: 500;
      color: ${palette('text', 0)};
      text-decoration: none;
      padding: 10px 20px;
      line-height: 1;
      border: 1px solid ${palette('border', 1)};
      display: flex;
      align-items: center;
      justify-content: center;
      ${transition()};

      &:hover {
        background-color: ${palette('primary', 0)};
        border-color: ${palette('primary', 0)};
        color: ${palette('grayscale', 5)};
      }
    }

    h3 {
      font-size: 14px;
      font-weight: 500;
      color: ${palette('text', 0)};
      line-height: 1.3;
    }
  }

  &.withImg {
    .isoDropdownListItem {
      display: flex;
      flex-direction: row;

      .isoImgWrapper {
        width: 35px;
        height: 35px;
        overflow: hidden;
        margin: ${props => (props['data-rtl'] === 'rtl' ? '0 0 0 15px' : '0 15px 0 0')};
        display: -webkit-inline-flex;
        display: -ms-inline-flex;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background-color: ${palette('grayscale', 9)};
        ${borderRadius('50%')};

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .isoListContent {
        width: 100%;
        display: flex;
        flex-direction: column;

        .isoListHead {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        h5 {
          margin-bottom: 0;
          padding: ${props => (props['data-rtl'] === 'rtl' ? '0 0 0 15px' : '0 15px 0 0')};
        }

        .isoDate {
          font-size: 11px;
          color: ${palette('grayscale', 1)};
          flex-shrink: 0;
        }

        p {
          white-space: normal;
          line-height: 1.5;
        }
      }
    }
  }

  &.isoUserDropdown {
    display: flex;
    flex-direction: column;
    background-color: ${palette('grayscale', 5)};
    width: 220px;
    min-width: 160px;
    flex-shrink: 0;
    ${borderRadius('5px')};
    ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
    ${transition()};

    .logout {
      text-align: ${props => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
    }

    .isoDropdownLink {
      z-index: 1;
      font-size: 14px;
      font-weight: 500;
      color: ${palette('grayscale', 0)};
      padding: 14px 23px;
      background-color: transparent;
      text-decoration: none;
      ${transition()};

      &:not(:last-child) {
        border-bottom: 1px solid ${palette('grayscale', 3)};
      }

      &:last-child {
        &:hover {
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
        }
      }

      &:first-child {
        &:hover {
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
        }
      }

      &:hover {
        background-color: ${palette('primary', 3)};
        color: ${palette('primary', 0)};
      }

      .dropdown-link-description {
        color: ${palette('grayscale', 2)};
        font-size: 10px;
        font-weight: 500;
        margin: 5px 30px 0 0;
      }
    }
  }
  ul.list {
    padding-left: 10px;
    margin: 0;
    margin-block-end: 0;
  }
`;

export default WithDirection(TopbarDropdownWrapper);
